import { render, staticRenderFns } from "./ups.vue?vue&type=template&id=394c8275"
import script from "./ups.vue?vue&type=script&lang=js"
export * from "./ups.vue?vue&type=script&lang=js"
import style0 from "./ups.vue?vue&type=style&index=0&id=394c8275&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports